<script lang="ts">
	import type { Menu, Category } from "../../../functions/place/types";
	import { DefaultSwitch } from "@hitit/new_ui/src";
	import { t } from "@hitit/hub/src/stores";
	import { createEventDispatcher } from "svelte";

	export let categories: Category[] = [];

	$: selectedCategoryIndex = 0;
	$: selectedCategory = categories[selectedCategoryIndex];
	$: selectedMenus = selectedCategory ? selectedCategory.menus : [];
	//
	const dispatch = createEventDispatcher();
	const hasVisibleMenu = (category: Category) => {
		const visibleMenus = category.menus.filter((v) => v.show);
		return visibleMenus.length > 0;
	};

	const allVisibleMenu = (category: Category) => {
		if (category.menus.length === 0) return;
		const visibleMenus = category.menus.filter((v) => v.show);
		return visibleMenus.length === category.menus.length;
	};

	const categorySwitchHandler = (index: number) => {
		const checked = !allVisibleMenu(categories[index]);
		dispatch("CHANGE_ALL_MENUS", {
			index: index,
			visible: checked,
		});
	};

	function menuSwitchHandler(categoryIndex: number, menuIndex: number) {
		dispatch("CHANGE_MENU", {
			index: [categoryIndex, menuIndex],
		});
	}

</script>

<div class="container" t-id="menu editor">
	<div class="header">
		<p class="desc">{$t('hub.place.Can_select_visible')}</p>
		<div class="categories">
			{#each categories as category, index}
				<div
					class="category"
					class:noVisibleMenus={!hasVisibleMenu(category)}
					class:selected={category === selectedCategory}
					on:click={() => (selectedCategoryIndex = index)}>
					{category.name}
				</div>
			{/each}
		</div>
		<div class="selected-category">
			{#if selectedCategory}
				<div class="switch">
					<DefaultSwitch
						checked={allVisibleMenu(selectedCategory)}
						on:change={() => categorySwitchHandler(selectedCategoryIndex)} />
				</div>
				<p>{selectedCategory.name}</p>
			{/if}
		</div>
	</div>
	<div class="menu-container">
		{#each selectedMenus as menu, index}
			<div class="menu">
				<div class="name-switch">
					<div class="name">{menu.name}</div>
					<div class="switch">
						<DefaultSwitch
							checked={menu.show}
							on:change={() => menuSwitchHandler(selectedCategoryIndex, index)} />
					</div>
				</div>
				{#if menu.desc && menu.desc.trim()}
					<div class="desc">{menu.desc}</div>
				{/if}
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		color: #46474b;
		font-weight: 500;

		.switch {
			height: 30px;
		}

		.header {
			display: flex;
			flex-direction: column;
			gap: 20px;
			.selected-category {
				display: flex;
				align-items: center;
				gap: 10px;
				word-break: break-all;
				font-size: 1.25rem;
			}

			.desc {
				color: #bcbfc3;
				font-size: 0.875rem;
				word-break: break-all;
				line-height: 20px;
			}

			.categories {
				display: flex;
				flex-wrap: wrap;
				gap: 10px 20px;

				.category {
					&.noVisibleMenus {
						color: #bcbfc3;
					}
					&.selected {
						color: #3c68d6;
					}
					&:hover {
						cursor: pointer;
					}
				}
			}
		}

		.menu-container {
			display: flex;
			flex-direction: column;
			.menu {
				display: flex;
				display: flex;
				flex-direction: column;
				gap: 1px;
				padding-top: 10px;
				padding-bottom: 10px;
				border-bottom: 1px solid #d8d9df;
				&:first-child {
					padding-top: 0px;
				}
				.name-switch {
					display: flex;
					align-items: center;

					.name {
						flex-grow: 1;
						word-break: break-all;
					}
				}
				.desc {
					word-break: break-all;
					font-size: 0.875rem;
					color: #6d6f76;
					font-weight: 200;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			gap: 23px;
			.header {
				.selected-category {
					font-weight: 600;
					font-size: 2.125rem;
				}
				.desc {
					font-weight: 200;
					font-size: 1rem;
				}
				.categories {
					gap: 10px 30px;
					font-size: 1.25rem;
				}
			}

			.menu-container {
				.menu {
					gap: 7px;
					.name-switch {
						font-size: 1.25rem;
					}
					.desc {
						font-size: 1.125rem;
					}
				}
			}
		}
	}

</style>
